/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faTriangleExclamation,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { Theme } from "@mui/material/styles";
import React from "react";

import type { ColorSchema } from "../../@types/theme";

export default function Alert(theme: Theme): any {
  const isLight = theme.palette.mode === "light";

  const standardStyle = (color: ColorSchema): any => ({
    color: theme.palette[color][isLight ? "darker" : "lighter"],
    backgroundColor: theme.palette[color][isLight ? "lighter" : "darker"],
  });

  const filledStyle = (color: ColorSchema): any => ({ color: theme.palette[color].contrastText });

  const outlinedStyle = (color: ColorSchema): any => ({
    color: theme.palette[color][isLight ? "darker" : "lighter"],
    border: `solid 1px ${theme.palette[color][isLight ? "light" : "dark"]}`,
    backgroundColor: theme.palette[color][isLight ? "lighter" : "darker"],
  });

  return {
    MuiAlert: {
      defaultProps: {
        iconMapping: {
          error: <FontAwesomeIcon icon={faCircleExclamation} />,
          info: <FontAwesomeIcon icon={faCircleInfo} />,
          success: <FontAwesomeIcon icon={faCircleCheck} />,
          warning: <FontAwesomeIcon icon={faTriangleExclamation} />,
        },
      },

      styleOverrides: {
        icon: { color: "inherit !important" },
        message: { "& .MuiAlertTitle-root": { marginBottom: theme.spacing(0.5) } },
        action: { "& button:not(:first-of-type)": { marginLeft: theme.spacing(1) } },

        standardInfo: standardStyle("info"),
        standardSuccess: standardStyle("success"),
        standardWarning: standardStyle("warning"),
        standardError: standardStyle("error"),

        filledInfo: filledStyle("info"),
        filledSuccess: filledStyle("success"),
        filledWarning: filledStyle("warning"),
        filledError: filledStyle("error"),

        outlinedInfo: outlinedStyle("info"),
        outlinedSuccess: outlinedStyle("success"),
        outlinedWarning: outlinedStyle("warning"),
        outlinedError: outlinedStyle("error"),
      },
    },
  };
}
